
      // Protección global: si ocurre cualquier error JS, la app no debe caerse
      try {
        // Estado global de splash
        let splashClosed = false
        const MIN_SPLASH_TIME = 500
        const splashStart = performance.now()

        // Cierra el splash de forma robusta y única
        function closeSplash(force = false) {
          if (splashClosed) return
          splashClosed = true
          const splash = document.getElementById('splash')
          const root = document.getElementById('root')
          if (splash) {
            splash.classList.add('loaded')
            // Fallback: siempre remover splash tras animación o a la fuerza
            const removeSplash = () => {
              if (splash.parentNode) splash.remove()
              document.body.style.overflow = ''
            }
            if (force === 'instant') {
              removeSplash()
            } else {
              setTimeout(removeSplash, 200)
              // Fallback extra: si por alguna razón no se remueve, forzar a los 1.5s
              setTimeout(() => {
                if (document.getElementById('splash')) removeSplash()
              }, 1500)
            }
          }
          if (root) root.classList.add('loaded')
        }

        // Fallback extremo: si el splash sigue visible después de 6s, lo remueve sí o sí
        setTimeout(() => {
          const splash = document.getElementById('splash')
          if (splash) {
            splash.remove()
            document.body.style.overflow = ''
          }
        }, 6000)

        // Actualiza el badge de cámara y guarda el estado global
        async function updateCameraBadge() {
          const badge = document.getElementById('camera-badge')
          const cameraSvg = document.getElementById('camera-svg')
          const cameraBody = document.getElementById('camera-body')
          const cameraLens = document.getElementById('camera-lens')
          if (!badge || !cameraSvg || !cameraBody || !cameraLens) return

          let permission = 'unknown'
          window.__cameraPermissionState = 'unknown'
          if (navigator.permissions && navigator.permissions.query) {
            try {
              const result = await navigator.permissions.query({ name: 'camera' })
              permission = result.state
              window.__cameraPermissionState = permission
            } catch {
              permission = 'unknown'
              window.__cameraPermissionState = 'unknown'
            }
          }
          // Cambia color según estado de permisos
          if (permission === 'granted') {
            cameraBody.setAttribute('stroke', '#22c55e') // verde
            cameraLens.setAttribute('fill', '#22c55e')
          } else if (permission === 'prompt') {
            cameraBody.setAttribute('stroke', '#facc15') // amarillo
            cameraLens.setAttribute('fill', '#facc15')
          } else if (permission === 'denied') {
            cameraBody.setAttribute('stroke', '#ef4444') // rojo
            cameraLens.setAttribute('fill', '#ef4444')
          } else {
            cameraBody.setAttribute('stroke', '#222')
            cameraLens.setAttribute('fill', '#222')
          }
        }

        // Splash: cerrar por click/touch si hay permiso
        function setupSplashClick() {
          const splash = document.getElementById('splash')
          if (!splash) return
          const tryClose = async e => {
            await updateCameraBadge()
            if (window.__cameraPermissionState === 'granted') {
              closeSplash('instant') // Cierre inmediato
            }
          }
          splash.addEventListener('click', tryClose, { once: false })
          splash.addEventListener('touchend', tryClose, { once: false })
        }

        // Splash: cerrar automáticamente si el permiso cambia a granted
        function setupCameraPermissionListener() {
          if (navigator.permissions && navigator.permissions.query) {
            navigator.permissions
              .query({ name: 'camera' })
              .then(function (result) {
                result.onchange = function () {
                  updateCameraBadge()
                  if (result.state === 'granted') {
                    closeSplash()
                  }
                }
                // Si ya está concedido al cargar
                if (result.state === 'granted') {
                  closeSplash()
                }
              })
              .catch(() => {})
          }
        }

        // Splash: cerrar por timeout (5s)
        function setupSplashTimeout() {
          setTimeout(() => {
            closeSplash(true)
          }, 5000)
        }

        // Botón de permiso de cámara
        function setupCameraPermissionBtn() {
          const btn = document.getElementById('camera-permission-btn')
          if (!btn) return
          btn.addEventListener('click', async e => {
            try {
              const stream = await navigator.mediaDevices.getUserMedia({ video: true })
              if (stream) {
                stream.getTracks().forEach(track => track.stop())
                setTimeout(() => {
                  closeSplash()
                }, 200)
              }
            } catch {}
            e.stopPropagation()
            e.preventDefault()
          })
        }

        // Inicialización
        window.addEventListener('DOMContentLoaded', () => {
          updateCameraBadge()
          setupSplashClick()
          setupCameraPermissionListener()
          setupSplashTimeout()
          setupCameraPermissionBtn()
        })
      } catch (err) {
        try {
          closeSplash(true)
        } catch {}
        console.error('Error crítico en la app (protegido):', err)
      }
    